import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from '@/lang/en'
import it from '@/lang/it'

Vue.use(VueI18n)

function getUserLocale () {
  return localStorage.getItem('locale') ||
    navigator.language.split('-')[0] ||
    'en'
}

export default new VueI18n({
  locale: getUserLocale(),
  fallbackLocale: 'en',
  messages: { en, it }
})
